import { HandicapEquipment } from "@/api/api";
import { Escort } from "@/models/Orders/OrderEnums";

export function getEscortOptionSheet(
  opt: {
    key: string;
    handicapEquipment: HandicapEquipment | null;
    escort: Escort | null;
  },
  isInMenu = true,
  isInList = false
) {
  if (opt.escort == null) {
    return {
      class: isInList ? "mr-2 rounded-circle" : "rounded-circle",
      style: isInMenu
        ? ""
        : "width:44px; height:44px; padding-top: 9px !important; margin-top: 4px",
    };
  }

  if (opt.escort == Escort.ChildLittle) {
    return {
      class: isInList ? "mr-3 kite-shape" : "kite-shape",
    };
  }

  if (opt.escort == Escort.Adult) {
    return {
      class: isInList ? "mr-2 rounded-circle" : "rounded-circle",
      style: isInMenu
        ? ""
        : "width:44px; height:44px; padding-top: 9px !important; margin-top: 4px",
    };
  }

  return {
    class: isInList ? "mr-2" : "",
    style: isInMenu
      ? ""
      : "width:44px; height:44px; padding-top: 9px !important; margin-top: 4px",
  };
}
